import React from 'react';
import styled from 'styled-components';
import {
  sectionMargins,
  brandColours,
  fontWeights,
  fontSize,
  minBreakpointQuery,
} from '../utilities';
import { Container, HeadingWithBackgroundText, Button } from './ui';
import { commonFormStyles } from './ui/FormFields';

const StyledForm = styled.section`
  ${sectionMargins()};
`;

const StyledFormInner = styled.form`
  display: grid;
  padding: 24px 0;

  ${minBreakpointQuery.medium`
    grid-template-columns: repeat(2, 1fr);
    column-gap: 16px;
    padding: 49px 0;
  `}
`;

const StyledFormLabel = styled.label`
  margin-bottom: 14px;

  ${minBreakpointQuery.medium`
      margin-bottom: 30px;
  `}
`;

const StyledFormLabelMessage = styled.label`
  margin-bottom: 14px;

  ${minBreakpointQuery.medium`
    grid-column: 1 / 3;
    margin-bottom: 26px;
  `}
`;

const StyledFormLabelText = styled.span`
  font-weight: ${fontWeights.bold};
  ${fontSize(16)};
  display: block;
  margin-bottom: 10px;

  ${minBreakpointQuery.medium`
    margin-bottom: 15px;
  `}
`;

const StyledFormInput = styled.input`
  ${commonFormStyles()};
  height: 60px;
`;

const StyledFormInputSelectWrap = styled.div`
  position: relative;

  &:after {
    content: '';
    position: absolute;
    top: 50%;
    right: 20px;
    height: 10px;
    width: 10px;
    border: 2px solid ${brandColours.secondary};
    border-top: 0;
    border-left: 0;
    pointer-events: none;
    transform: translateY(-6px) rotate(45deg);
  }
`;

const StyledFormInputSelect = styled.select`
  ${commonFormStyles()};
  padding-right: 42px;
  height: 60px;
`;

const StyledFormInputMessage = styled.textarea`
  ${commonFormStyles()};
  min-height: 140px;

  ${minBreakpointQuery.medium`
    min-height: 200px;
  `}
`;

const ContactForm = ({ heading, headingBackgroundText, membership }) => {
  return (
    <StyledForm>
      <Container>
        <HeadingWithBackgroundText
          heading={heading}
          headingBackgroundText={headingBackgroundText}
        />
        <StyledFormInner
          name={membership ? 'membership' : 'contact'}
          method="POST"
          action="/thanks"
          data-netlify={true}
        >
          <input
            type="hidden"
            name="form-name"
            value={membership ? 'membership' : 'contact'}
          />
          <StyledFormLabel>
            <StyledFormLabelText>Name*</StyledFormLabelText>
            <StyledFormInput
              type="text"
              name="name"
              placeholder="Enter Your Name"
              required
            />
          </StyledFormLabel>
          <StyledFormLabel>
            <StyledFormLabelText>Email*</StyledFormLabelText>
            <StyledFormInput
              type="email"
              name="email"
              placeholder="Enter Your Email"
              required
            />
          </StyledFormLabel>
          {membership && (
            <>
              <StyledFormLabel>
                <StyledFormLabelText>Phone Number</StyledFormLabelText>
                <StyledFormInput
                  type="tel"
                  name="phone-number"
                  placeholder="Enter Your Phone Number"
                />
              </StyledFormLabel>
              <StyledFormLabel>
                <StyledFormLabelText>Child&#39;s Name*</StyledFormLabelText>
                <StyledFormInput
                  type="text"
                  name="childs-name"
                  placeholder="Enter Your Child&#39;s Name"
                  required
                />
              </StyledFormLabel>
              <StyledFormLabel>
                <StyledFormLabelText>
                  Child&#39;s Date of Birth*
                </StyledFormLabelText>
                <StyledFormInput
                  type="date"
                  name="childs-dob"
                  placeholder="Enter Your Child&#39;s DOB"
                  required
                />
              </StyledFormLabel>
              <StyledFormLabel>
                <StyledFormLabelText>Preferred Class Day</StyledFormLabelText>
                <StyledFormInputSelectWrap>
                  <StyledFormInputSelect
                    type="select"
                    name="class-day"
                    defaultValue=""
                  >
                    <option value="" disabled>
                      Please Select
                    </option>
                    <option value="Saturday">Saturday</option>
                  </StyledFormInputSelect>
                </StyledFormInputSelectWrap>
              </StyledFormLabel>
            </>
          )}
          <StyledFormLabelMessage>
            <StyledFormLabelText>Message*</StyledFormLabelText>
            <StyledFormInputMessage
              name="message"
              placeholder="Enter Your Message Here..."
              required
            />
          </StyledFormLabelMessage>
          <Button type="submit">Submit Details</Button>
        </StyledFormInner>
      </Container>
    </StyledForm>
  );
};

export default ContactForm;
